class CopyEntityCtrl {

    constructor($scope, $uibModalInstance, entity, title, multiple, ApiService, CONTENT_TYPE, Notification, EVENTS, $rootScope, $q) {

        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.$scope.title = title;
        this.$scope.entity = entity;
        this.$scope.multiple = multiple;
        this.$scope.originalEntities = entity;
        this.$q = $q;

        if(!$scope.multiple) {
            this.$scope.entity = $.extend( {}, entity );
        }
        else {
           this.$scope.entity = $.extend( {}, entity[0] ); 
       }

        this.$scope.targetEntity = null;
        this.$scope.ok = this.ok.bind(this);
        this.$scope.cancel = this.cancel.bind(this);
        this.ApiService = ApiService;
        this.CONTENT_TYPE = CONTENT_TYPE;
        this.EVENTS = EVENTS;
        this.Notification = Notification;
        this.$rootScope = $rootScope;

        this.$scope.reset = this.reset.bind(this);
    }

    reset() {
        this.$scope.$broadcast(this.EVENTS.COPY_RESET);
    }

    ok() {
        let contentType = this.$scope.entity.contentType.replace("x-reflow/", "");
        if(this.$scope.multiple) {

            this.createdEnitities = null;
            let length = this.$scope.originalEntities.length;
            let firstEntity = this.$scope.originalEntities[0];
            this.$scope.loading = true;
            firstEntity.entitiesToCreate = this.$scope.targetEntity.entitiesToCreate;


            this.ApiService.clone(firstEntity, this.$scope.targetEntity, this.CONTENT_TYPE[contentType.toUpperCase()])
                .then((response) => {
                    console.log(response.data);
                    this.createdEnitities = response.data;

                    let requests = [];

                    this.$scope.originalEntities.forEach((entity, i) => {
                        entity.entitiesToCreate = this.createdEnitities;
                        if(i !== 0) {
                            requests.push(this.ApiService.clone(entity, this.$scope.targetEntity, this.CONTENT_TYPE[contentType.toUpperCase()]));
                        }
                    });

                    this.$q.all(requests).then(response => {
                        let obj = !!response[0].data ? response[0].data : response[0][contentType].data;
                        this.$rootScope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Successfully copied ' + length + " " + contentType + "s"});
                        this.$rootScope.$emit(this.EVENTS.COPY_COMPLETE, response[0].data);
                        this.$scope.loading = false;
                    });
                }, (response) => {
                    console.error(response);
                    console.error(response);
                    this.$scope.error = true;
                    this.loading = false;
                });
        }
        else {

            this.ApiService.clone(this.$scope.entity, this.$scope.targetEntity, this.CONTENT_TYPE[contentType.toUpperCase()])
                .then((response) => {
                    this.$rootScope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Successfully copied ' + this.$scope.entity.name});
                    this.$rootScope.$emit(this.EVENTS.COPY_COMPLETE, response.data);
                }, (response) => {
                    console.error(response);
                    console.error(response);
                    this.$scope.error = true;
                });
        }

        this.$uibModalInstance.close(this.$scope.targetEntity);
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

}

angular.module("cpm").controller("CopyEntityCtrl", ['$scope', '$uibModalInstance','entity', 'title', 'multiple', 'ApiService', 'CONTENT_TYPE', 'Notification', 'EVENTS', '$rootScope', '$q', CopyEntityCtrl]);
